// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"visuallyHidden__9d4f66"};